import map from 'lodash/map';
import clone from 'lodash/clone';

export const sortLessons = (lessons, ignoreFinished = false) => {
  if (!lessons || !lessons.length) return [];

  let lessonsClone = map(lessons, clone);

  function isFinished(trigger) {
    if (ignoreFinished) return false;
    const childTriggers = lessons.filter(
      ({ parent_trigger }) => parent_trigger === trigger.id
    );
    return trigger.finished && childTriggers.every(({ finished }) => finished);
  }

  function getOrder(trigger) {
    return (trigger.sorting_time || 0) + (trigger.order || 0);
  }

  function sortLessons(a, b) {
    let af, bf, ao, bo;

    af = isFinished(a);
    bf = isFinished(b);

    if (af && !bf) {
      return 1;
    }

    if (!af && bf) {
      return -1;
    }

    ao = getOrder(a);
    bo = getOrder(b);

    return ao < bo ? -1 : 1;
  }

  return lessonsClone.sort(sortLessons);
};

export const sortCourses = (courses) => {
  const bottom = Infinity;

  return courses.sort((a, b) => {
    let groupA = getCourseStatusGroup(a);
    let groupB = getCourseStatusGroup(b);
    if (groupA !== groupB) {
      return groupA - groupB;
    }

    let showOrderA = a.show_order ?? bottom;
    let showOrderB = b.show_order ?? bottom;

    if (showOrderA !== showOrderB) {
      return showOrderA - showOrderB;
    }

    // new campaigns first
    return b.created_at - a.created_at;
  });
};

export const getValidCourseTriggers = (triggers) => {
  return triggers.filter((l) => {
    if (!l.parent_trigger) return true;
    return triggers.some(({ id, include_extra_lessons }) => {
      return id === l.parent_trigger && include_extra_lessons;
    });
  });
};

export const isCourseStarted = (course) => {
  const { triggers, completed_lessons_count } = course;
  if (completed_lessons_count > 0) return true;
  if (triggers?.length)
    return getValidCourseTriggers(triggers).some((t) => t.finished);
  return false;
};

export const isCourseCompleted = (course) => {
  const {
    triggers,
    total_lessons_count,
    completed_lessons_count,
    type,
    schemaLevel,
  } = course;

  if (triggers?.length) {
    return getValidCourseTriggers(triggers).every((t) => t.finished);
  }

  if (type === 'workflow') {
    // Full schema with no remaining triggers but with lessons means all
    // conditional branches have been completed and nothing remains.
    return schemaLevel === 'full' && total_lessons_count > 0;
  }

  return (
    total_lessons_count > 0 && completed_lessons_count === total_lessons_count
  );
};

export const getCourseProgress = (course) => {
  const { triggers, total_lessons_count, completed_lessons_count } = course;
  if (triggers?.length) {
    const valid = getValidCourseTriggers(triggers);
    return valid.length
      ? Math.round(
          (valid.filter((t) => t.finished).length / valid.length) * 100
        )
      : 0;
  }
  if (total_lessons_count > 0) {
    return Math.round((completed_lessons_count / total_lessons_count) * 100);
  }
  return 0;
};

const getCourseStatusGroup = (course) => {
  const started = isCourseStarted(course);
  const finished = started && isCourseCompleted(course);
  return started ? (finished ? 3 : 2) : 1;
};
